import { isMobile } from "./isMobile";

/*
 * Fixed position header
 * ----------------------------------------------- */
jQuery(window).on("load resize", function () {
  if (isMobile()) {
    var $hamburgerOpen = $(".hamburger-open");
    var $hamburgerClose = $(".hamburger-close");

    $hamburgerOpen.on("click", function () {
      $(".navbar-collapse").addClass("open");
    });

    $hamburgerClose.on("click", function () {
      $(".navbar-collapse").removeClass("open");
    });
  }
});
